


export const asValue = (value:any) => typeof value === 'string' ? value : value.value